import React from 'react';

const Footer = () => {
    return (
        <footer className="p-2 text-center" style={{ background: "gray", color: "white", marginBottom: "0px" }}>
            Designed By LIKITA S RAI
        </footer>
    );
}

export default Footer;